/* Dot-navigated testimonial carousel for .product-hero-testimonials (buy-box block).
   Dots, touch swipe, and mouse/pen drag on non-touch screens. */
(() => {
  const AUTOPLAY_INTERVAL = 4000;
  const SWIPE_THRESHOLD = 40;
  const DRAG_START_THRESHOLD = 5;
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('[data-testimonial-slider]').forEach((root) => {
    const track = root.querySelector('[data-testimonial-track]');
    const slides = Array.from(
      root.querySelectorAll('[data-testimonial-slide], .product-hero-testimonials__slide')
    );
    const dots = Array.from(root.querySelectorAll('[data-testimonial-dot]'));
    const announcer = root.querySelector('[data-testimonial-announcer]');
    if (!track || slides.length < 2) return;

    let index = 0;
    let autoplayTimer = null;
    let pointerId = null;
    let dragStartX = null;
    let dragOffset = 0;
    let isDragging = false;

    track.style.cursor = 'grab';
    track.style.touchAction = 'pan-y';

    function render(newIndex, { silent } = {}) {
      index = (newIndex + slides.length) % slides.length;
      track.style.transform = `translateX(-${index * 100}%)`;
      slides.forEach((slide, i) => slide.setAttribute('aria-hidden', i === index ? 'false' : 'true'));
      dots.forEach((dot, i) => dot.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      if (!silent && announcer) announcer.textContent = `Slide ${index + 1} of ${slides.length}`;
    }

    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // WCAG 2.2.2: auto-advancing content must be pausable — reduced-motion users don't
    // get autoplay at all, everyone else pauses it on hover/focus/an off-screen tab.
    function startAutoplay() {
      if (reducedMotion.matches || document.hidden || isDragging) return;
      stopAutoplay();
      autoplayTimer = setInterval(() => render(index + 1), AUTOPLAY_INTERVAL);
    }

    function restoreTransition() {
      track.style.transition = reducedMotion.matches ? 'none' : '';
    }

    function endDrag(event) {
      if (pointerId === null || event.pointerId !== pointerId) return;

      const offset = dragOffset;
      const didDrag = isDragging;

      try {
        track.releasePointerCapture(pointerId);
      } catch (_) {
        /* already released */
      }

      pointerId = null;
      dragStartX = null;
      dragOffset = 0;
      isDragging = false;
      root.classList.remove('is-dragging');
      track.style.cursor = 'grab';
      track.style.userSelect = '';
      restoreTransition();

      if (didDrag && Math.abs(offset) >= SWIPE_THRESHOLD) {
        render(offset < 0 ? index + 1 : index - 1);
      } else {
        render(index, { silent: true });
      }
      startAutoplay();
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        render(i);
        startAutoplay();
      });
    });

    if (reducedMotion.matches) {
      track.style.transition = 'none';
    }

    track.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;
      if (event.target.closest('[data-testimonial-dot], a, button')) return;

      pointerId = event.pointerId;
      dragStartX = event.clientX;
      dragOffset = 0;
      isDragging = false;
      stopAutoplay();
      track.setPointerCapture(pointerId);
      track.style.transition = 'none';
      track.style.userSelect = 'none';
    });

    track.addEventListener('pointermove', (event) => {
      if (pointerId === null || event.pointerId !== pointerId || dragStartX === null) return;

      dragOffset = event.clientX - dragStartX;
      if (!isDragging && Math.abs(dragOffset) >= DRAG_START_THRESHOLD) {
        isDragging = true;
        root.classList.add('is-dragging');
        track.style.cursor = 'grabbing';
      }
      if (!isDragging) return;

      track.style.transform = `translateX(calc(-${index * 100}% + ${dragOffset}px))`;
      event.preventDefault();
    });

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);

    root.addEventListener('mouseenter', stopAutoplay);
    root.addEventListener('mouseleave', () => {
      if (!isDragging) startAutoplay();
    });
    root.addEventListener('focusin', stopAutoplay);
    root.addEventListener('focusout', startAutoplay);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stopAutoplay();
      else startAutoplay();
    });

    render(0, { silent: true });
    startAutoplay();
  });
})();
